import React from "react";
import { motion } from "framer-motion";
import content from "../content/content.json";

const TradeSection = ({ activeIndex = 0, onScrollClick }) => {
  const { tradeSection, shared } = content;
  const active = Math.min(Math.max(activeIndex, 0), tradeSection.slides.length - 1);

  return (
    <section className="relative h-full w-full overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center transition-all duration-700"
        style={{ backgroundImage: `url(${tradeSection.slides[active].img})` }}
      />
      <div className="absolute inset-0 bg-[#1a1f2b]/50" />

      <div className="relative z-10 h-full flex flex-col justify-between px-10 md:px-20 py-12 text-white">
        <div className="mt-20">
          {tradeSection.slides[active].title && (
            <p className="uppercase tracking-wide text-gray-300 font-semibold">{tradeSection.slides[active].title}</p>
          )}
          <h1 className="text-5xl md:text-6xl font-extrabold leading-tight max-w-2xl mt-2">
            {tradeSection.slides[active].subtitle}
          </h1>
          {tradeSection.slides[active].supporting && (
            <p className="mt-3 text-gray-300 text-lg max-w-xl mb-4">{tradeSection.slides[active].supporting}</p>
          )}
         
          <a href={tradeSection.slides[active].href} className="mt-10 border-b-2 border-white pb-1 hover:text-red-500 transition">
            {tradeSection.slides[active].cta} {shared.arrow}
          </a>
        </div>

        <div className="space-y-4">
          <div className="w-full h-[2px] bg-gray-500 relative">
            <motion.div
              className="absolute top-0 left-0 h-[2px] bg-red-600"
              initial={{ width: 0 }}
              animate={{ width: `${((active + 1) / tradeSection.slides.length) * 100}%` }}
              transition={{ duration: 0.6 }}
            />
          </div>

          <div className="flex gap-6 overflow-x-auto pb-4">
            {tradeSection.slides.map((slide, i) => (
              <div
                key={slide.title}
                className={`relative w-52 h-32 flex-shrink-0 border-2 transition ${
                  i === active ? "border-white" : "border-transparent"
                }`}
              >
                <img src={slide.img} alt={slide.title} className="h-full w-full object-cover" />
                <div className="absolute inset-0 bg-black/40 flex items-end p-3">
                  <p className={`text-sm font-semibold ${i === active ? "text-white" : "text-gray-300"}`}>
                    {slide.title}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <button
        type="button"
        onClick={onScrollClick}
        className="absolute z-20 bottom-24 right-6 bg-white text-gray-800 text-sm font-semibold tracking-wider px-6 py-3 shadow-md rounded-sm flex items-center gap-2 hover:bg-gray-100 transition-colors"
      >
        {tradeSection.skip} <span className="text-lg">{shared.downArrow}</span>
      </button>
    </section>
  );
};

export default TradeSection;
